// Version : 0.0.5
// LastEdit : KARTHEESWARAN
// MODFIED DATA : 13-08-2025
import PurposeOfLoanTypeActionTypes from './purpose-of-loan-type.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// PURPOSE OF LOAN TYPE STATES
	purposeOfLoanTypeResp: null,
	purposeOfLoanTypeRespArr: [],
	purposeOfLoanTypeAddStatus: null,
	purposeOfLoanTypeAddResp: null,
	purposeOfLoanTypeUpdateStatus: null,
	purposeOfLoanTypeUpdateResp: null,
	purposeOfLoanTypeDeleteStatus: null,
	purposeOfLoanTypeDeleteResp: null,
	deletePurposeOfLoanTypeDetailsResponse: null,
	fetchPurposeOfLoanTypeDetailsResponse: null,
	fetchPurposeOfLoanTypeDetailsArr: [],
	updatePurposeOfLoanTypeDetailsResponse: null,
};

const purposeofLoanTypeReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET PURPOSE OF LOAN TYPE START *********************** */
		case PurposeOfLoanTypeActionTypes.GET_PURPOSE_OF_LOAN_TYPE_SUCCESS:
			return {
				...state,
				purposeOfLoanTypeResp: action.payload,
				purposeOfLoanTypeRespArr: docodeHexResponse(
					action.payload,
					'purposeOfLoanTypeListKey',
				),
			};

		case PurposeOfLoanTypeActionTypes.GET_PURPOSE_OF_LOAN_TYPE_FAILURE:
			return { ...state, purposeOfLoanTypeResp: action.payload };

		case PurposeOfLoanTypeActionTypes.GET_PURPOSE_OF_LOAN_TYPE_RESPONSE_CHANGED:
			return { ...state, purposeOfLoanTypeResp: null };
		/** ***************** GET PURPOSE OF LOAN TYPE END *********************** */

		/** ***************** ADD PURPOSE OF LOAN TYPE START *********************** */
		case PurposeOfLoanTypeActionTypes.ADD_PURPOSE_OF_LOAN_TYPE_SUCCESS:
			return { ...state, purposeOfLoanTypeAddStatus: action.payload };

		case PurposeOfLoanTypeActionTypes.ADD_PURPOSE_OF_LOAN_TYPE_FAILURE:
			return { ...state, purposeOfLoanTypeAddStatus: null };

		case PurposeOfLoanTypeActionTypes.ADD_PURPOSE_OF_LOAN_TYPE_RESPONSE_CHANGED:
			return { ...state, purposeOfLoanTypeAddStatus: null };
		/** ***************** ADD PURPOSE OF LOAN TYPE END *********************** */

		/** ***************** DELETE PURPOSE OF LOAN TYPE DETAILS START *********************** */
		case PurposeOfLoanTypeActionTypes.DELETE_PURPOSE_OF_LOAN_TYPE_SUCCESS:
			return { ...state, deletePurposeOfLoanTypeDetailsResponse: action.payload };

		case PurposeOfLoanTypeActionTypes.DELETE_PURPOSE_OF_LOAN_TYPE_FAILURE:
			return { ...state, deletePurposeOfLoanTypeDetailsResponse: action.payload };

		case PurposeOfLoanTypeActionTypes.DELETE_PURPOSE_OF_LOAN_TYPE_RESPONSE_CHANGED:
			return { ...state, deletePurposeOfLoanTypeDetailsResponse: null };
		/** ***************** DELETE PURPOSE OF LOAN TYPE DETAILS END *********************** */

		/** ***************** FETCH PURPOSE OF LOAN TYPE DETAILS START *********************** */
		case PurposeOfLoanTypeActionTypes.FETCH_PURPOSE_OF_LOAN_TYPE_DETAILS_SUCCESS:
			return {
				...state,
				fetchPurposeOfLoanTypeDetailsResponse: action.payload,
				fetchPurposeOfLoanTypeDetailsArr: docodeHexResponse(
					action.payload,
					'FetchPurposeOfLoanTypeDetailsKey',
				),
			};

		case PurposeOfLoanTypeActionTypes.FETCH_PURPOSE_OF_LOAN_TYPE_DETAILS_FAILURE:
			return { ...state, fetchPurposeOfLoanTypeDetailsResponse: action.payload };

		case PurposeOfLoanTypeActionTypes.FETCH_PURPOSE_OF_LOAN_TYPE_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				fetchPurposeOfLoanTypeDetailsResponse: null,
			};
		/** ***************** FETCH PURPOSE OF LOAN TYPE DETAILS END *********************** */

		/** ***************** UPDATE PURPOSE OF LOAN TYPE DETAILS START *********************** */
		case PurposeOfLoanTypeActionTypes.UPDATE_PURPOSE_OF_LOAN_TYPE_DETAILS_SUCCESS:
			return { ...state, updatePurposeOfLoanTypeDetailsResponse: action.payload };

		case PurposeOfLoanTypeActionTypes.UPDATE_PURPOSE_OF_LOAN_TYPE_DETAILS_FAILURE:
			return { ...state, updatePurposeOfLoanTypeDetailsResponse: action.payload };

		case PurposeOfLoanTypeActionTypes.UPDATE_PURPOSE_OF_LOAN_TYPE_DETAILS_RESPONSE_CHANGED:
			return { ...state, updatePurposeOfLoanTypeDetailsResponse: null };
		/** ***************** UPDATE PURPOSE OF LOAN TYPE DETAILS END *********************** */

		default:
			return state;
	}
};

export default purposeofLoanTypeReducer;
